// The dimensions a strong Suno Style prompt covers, in display order, each with a glyph.
// Shared by the smart editor (inline "missing" placeholders) and any score UI. Keys match
// the Ruby PromptHints::Analyzer dimension keys.
export interface PromptDimension {
  key: string
  label: string
  icon: string
  // 'polish' dimensions (Suno's dynamics / structure / harmony) are optional bonuses —
  // detected and suggested, but they don't count toward the completeness score.
  tier?: 'core' | 'polish'
}

export const PROMPT_DIMENSIONS: PromptDimension[] = [
  { key: 'genre', label: 'genre', icon: '🎼' },
  { key: 'mood', label: 'mood', icon: '😊' },
  { key: 'instrumentation', label: 'instruments', icon: '🎸' },
  { key: 'percussion', label: 'percussion', icon: '🥁' },
  { key: 'tempo', label: 'tempo', icon: '⏱️' },
  { key: 'vocals', label: 'vocals', icon: '🎤' },
  { key: 'production', label: 'production', icon: '🎛️' },
  { key: 'dynamics', label: 'dynamics', icon: '📈', tier: 'polish' },
  { key: 'structure', label: 'structure', icon: '🧱', tier: 'polish' },
  { key: 'harmony', label: 'harmony', icon: '🎹', tier: 'polish' },
]
